import type { IProfileService } from "App/Modules/Auth";

import type { IFormContainerResolve } from "App/Modules/Services";

import type { IComponentController } from "angular";
import "angular-translate";

import type { IEnumService, IUserNotificationSettings } from "App/Modules/Models";
import { NotificationChannel } from "App/Modules/Models";

export default class ProfileNotificationSettingsEditComponentController implements IComponentController {
    public static $inject = ["mmProfileService", "mmEnumService"];

    public notificationChannels: Array<{ key: number; value: string }>;

    public notificationSettings: IUserNotificationSettings[];

    public resolve: IFormContainerResolve<IUserNotificationSettings[], void>;

    constructor(private profileService: IProfileService, private enumService: IEnumService) {}

    public $onInit() {
        this.notificationSettings = this.resolve.formData;
        this.notificationChannels = this.enumService.enumToArray(NotificationChannel);

        // eslint-disable-next-line no-restricted-syntax
        for (const notificationSetting of this.notificationSettings) {
            // eslint-disable-next-line no-bitwise
            notificationSetting.notificationChannel |= NotificationChannel.Portal;
        }
    }

    public cancel() {
        this.resolve.options.onCancel();
    }

    public save() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.profileService.patchNotificationSettings(this.notificationSettings).subscribe((notificationSettings) => {
            this.resolve.options.onOk(this.notificationSettings);
        });
    }
}
